import { DataBean } from "../DataBean";

export class DepreciationTime extends DataBean {




    public async importDepreciationTimeUpdateForItems(filename: any, directory: any, dataStore: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importDepreciationTimeUpdateForItems_String_String_String", [filename, directory, dataStore]);
    }

}